import { IBasePickerSuggestionsProps, IPersonaProps } from "office-ui-fabric-react";
import { IUserProfile } from "../../../features/Auth/types";

export interface IPeoplePickerState {
    currentPicker?: number | string;
    delayResults?: boolean;
    peopleList: IPersonaProps[];
    currentSelectedItems?: IPersonaProps[];
    isValid?: boolean | null;
    isLoading?: boolean | null
}
export enum PrincipalType {
    Any = 0,
    People = 1,
    Group = 2,
}
export interface IPeoplePickerProps {
    userProfile: IUserProfile | undefined,
    principalType: PrincipalType,
    defaultValue: IPersonaProps[] | undefined,
    objectIds?: string[] | undefined,
    itemLimit: number | undefined,
    isRequired: boolean,
    errorMessage: string,
    onChange?: any,
    disabled?: boolean,
    componentRef?: any
    readonly?: boolean,
}

export const suggestionProps: IBasePickerSuggestionsProps = {
    suggestionsHeaderText: "Suggested People",
    mostRecentlyUsedHeaderText: "Suggested Contacts",
    noResultsFoundText: "No results found",
    loadingText: "Loading",
    showRemoveButtons: false,
    suggestionsAvailableAlertText: "People Picker Suggestions available",
    suggestionsContainerAriaLabel: "Suggested contacts",
};


export interface PeoplePickerQuery {
    queryParams: PeoplePickerQueryParams;
}

export interface PeoplePickerQueryParams {
    QueryString: string;
    MaximumEntitySuggestions: number;
    AllowEmailAddresses: boolean;
    PrincipalType: number;
    PrincipalSource: number;
    SharePointGroupID: number;
}